export enum SizeFilterUnits {
  gb = 'gb',
  mb = 'mb',
  kb = 'kb',
}
